export const DRAFT_SAVED_DATE_TIME = 'draft-saved-date-time';
export const DELETE_SPECIAL_CONSIDERATION = 'delete-special-consideration';
export const GET_REVIEW_BY_UUID = 'GET_REVIEW_BY_UUID';
export const GET_SC_ACKNOWLEDGEMENT_REQUEST = 'GET_SC_ACKNOWLEDGEMENT_REQUEST';
export const GET_SPECIAL_CONSIDERATION_SUMMARY = 'GET_SPECIAL_CONSIDERATION_SUMMARY';
